import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import * as Styles from './GradientButton.styles';
import { HAS_MOUSE_EFFECTS } from './GradientButton.enum';

const GradientButton = ({
  onClick = () => null,
  testId = 'gradient-button',
  label = '',
  iconLeft = null,
  iconRight = null,
  variant = 'primary',
  width = 'fit',
  size = 'lg',
  gradientVariant = 'darkBlueGradient',
  disabled = false,
}) => {
  const gradientRef = React.useRef(null);

  const handleMouseEffects = () => {
    const button = gradientRef.current;
    if (!button) return;

    const handleMouseMove = (e) => {
      const rect = button.getBoundingClientRect();
      const x = (e.clientX - rect.left) * 100 / button.clientWidth;
      const y = (e.clientY - rect.top) * 100 / button.clientHeight;
      button.style.setProperty('--mouse-x', x);
      button.style.setProperty('--mouse-y', y);
    };

    const handleMouseOut = () => {
      button.style.setProperty('--mouse-x', 0);
      button.style.setProperty('--mouse-y', 50);
    };

    button.addEventListener('mousemove', handleMouseMove);
    button.addEventListener('mouseout', handleMouseOut);

    return () => {
      button.removeEventListener('mousemove', handleMouseMove);
      button.removeEventListener('mouseout', handleMouseOut);
    };
  };

  const handleClick = () => {
    onClick && onClick();
  };

  useEffect(() => {
    handleMouseEffects();
  }, []);

  const buttonEffects = Object.values(HAS_MOUSE_EFFECTS.button);
  const hasButtonEffect = buttonEffects.includes(variant);
  const labelEffects = Object.values(HAS_MOUSE_EFFECTS.label);
  const haslabelEffect = labelEffects.includes(variant);

  return (
    <Styles.GradientButton
      type="button"
      data-testid={testId}
      onClick={handleClick}
      $variant={variant}
      ref={hasButtonEffect ? gradientRef : null}
      $width={width}
      $size={size}
      $gradientVariant={gradientVariant}
      disabled={disabled}
    >
      {iconLeft}
      <Styles.GradientButtonLabel
        ref={haslabelEffect ? gradientRef : null}
        $size={size}
        $variant={variant}
        $disabled={disabled}
      >
        {label}
      </Styles.GradientButtonLabel>
      {iconRight}
    </Styles.GradientButton>
  );
};

GradientButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  testId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  iconLeft: PropTypes.node,
  variant: PropTypes.string,
  width: PropTypes.string,
};

export default GradientButton;
